import { h } from '@debbie/cortex/dist/index.js'
import { useMe } from '@debbie/cortex/dist/me/index.js'
import { RootState } from '@debbie/cortex/dist/reducer.js'
import {
  Content,
  PageBase,
  SubMenu,
  TopNav,
  UserSettings,
} from '@debbie/iris/dist/components/index.js'
import React from 'react'
import { useSelector } from 'react-redux'
import { Route, Switch, useLocation } from 'react-router'

import Developers from './developers/Developers.js'
import Users from './Users.js'

const Settings = () => {
  const location = useLocation()

  const meLoadable = useMe()
  const me = h.hasData(meLoadable) ? meLoadable.data : null
  const lang = useSelector((s: RootState) => s.lang)

  const settingsItems = [
    {
      text: lang.navigation.myAccount,
      link: '/settings',
    },
    {
      text: lang.navigation.settingsUsers,
      link: '/settings/users',
    },
    {
      text: lang.navigation.settingsDevelopers,
      link: '/settings/developers',
      exact: false,
    },
  ]

  return (
    <div>
      <TopNav />
      <Content withSubMenu={true}>
        <PageBase>
          <SubMenu items={settingsItems} />
          <Switch location={location}>
            <Route path="/settings/developers">
              <Developers />
            </Route>
            <Route path="/settings/users">
              <Users />
            </Route>
            <Route path="/settings">
              {me && <UserSettings userId={me.id} />}
            </Route>
          </Switch>
        </PageBase>
      </Content>
    </div>
  )
}

export default Settings
